<script src="<%= BASE_URL %>plugins/jquery/jquery-3.6.0.min.js"></script>
<template>
  <div id="app">
   <div id="languageApp" v-if="!isAuthRoute">
     <LangSwitcher />
   </div>
   <transition name="fade" mode="out-in">
    <router-view/>
   </transition>
  </div>
</template>


<script>
export const RUTA_SERVIDOR = process.env.VUE_APP_RUTA_API;
export const RUTA_SERVIDOR_SHAREPOINT = process.env.VUE_APP_RUTA_API_SHAREPOINT;
import { ES } from '@/language/es.js'
import { EN } from '@/language/en.js'
import { IT } from '@/language/it.js'
import { AR } from '@/language/ar.js'
import LangSwitcher from '@/components/LangSwitcher.vue'

export default{
  components: { LangSwitcher },
  data(){
    return{
      ES,
      EN,
      IT,
      AR
    };
  },
  computed:{
    isAuthRoute(){
      return this.$route.matched.some(r => r.meta.requiresAuth);
    }
  },
  created:function(){
    localStorage.setItem('ES', JSON.stringify(this.ES));
    localStorage.setItem('EN', JSON.stringify(this.EN));
    localStorage.setItem('IT', JSON.stringify(this.IT));
    localStorage.setItem('AR', JSON.stringify(this.AR));
    if(!localStorage.getItem('language')){
      localStorage.setItem('language', 'ES');
    }
    const currentLang = localStorage.getItem('language') || 'ES';
    localStorage.setItem('languageInfo', localStorage.getItem(currentLang));
  }
}
</script>
<style scoped>
.fade-enter, .fade-leave-to {
  opacity: 0;
  transform: translateX(2em);
}
.fade-enter-active, .fade-leave-active {
  transition: all .3s ease;
}

#languageApp {
  position: fixed;
  right: 16px;
  top: 16px;
  z-index: 9999;
}
</style>